import {observer} from 'mobx-react';
import React, {useEffect} from 'react';
import {MatCustomization} from '../../../i';
import s from '../../../s';
import AbTestStore, {ABTestKeys} from '../../../../global/store/ab-test.store';
import {Portal} from '../../../../util';

declare const bootstrap: any;

type MatListProps = {
    collapsed: boolean;
    collapsedNumber: number;
    save: (id: number) => void;
    isModal?: boolean;
};

export const MatList = observer((props: MatListProps) => {
    const {isModal, collapsed, collapsedNumber, save} = props;

    useEffect(() => {
        const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        const popoverList = popoverTriggerList.map(function (popoverTriggerEl: any) {
            return new bootstrap.Popover(popoverTriggerEl);
        });
    }, []);

    return (
        <div
            className="mat-prod"
            role="listbox"
            aria-label="Select matting"
            style={{justifyContent: isModal ? 'space-around' : ''}}
        >
            {/* .sort((a, b) => collapsed ? a.id === s.ps.moulding_id ? -1 : b.id === s.ps.moulding_id ? 1 : 0 : 1) */}
            {s.prod.mats
                .slice(0, 1000)
                .slice(0, collapsedNumber)
                .map((m: MatCustomization, i: number) => (
                    <div
                        data-bs-toggle={window.innerWidth > 1200 ? 'popover' : ''}
                        data-bs-placement="top"
                        data-bs-html="true"
                        data-bs-trigger="hover focus"
                        data-bs-content={`<div class="prod-img-zoom"><img height="220" width="220" src="https://${Portal?.CDNDomain}/images/entities/matcombos/220_${m.mat1_id}${m.mat2_id && m.mat2_id > 0 ? `_${m.mat2_id.toString()}` : ''}.png" alt="" /></div>`}
                        title={m.title}
                        id={`mat-${m.id}`}
                        role="option"
                        key={m.id}
                        aria-label={`Select ${m.title} mat`}
                        className={`${AbTestStore.ABGetClassName(ABTestKeys.product_mats)}cust-entity${s.ps.matcombo_id === m.id ? ' active' : ''}${!collapsed ? ' active-bold' : ''}`}
                        onClick={() => save(m.id)}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                save(m.id);
                            }
                        }}
                        tabIndex={0}
                    >
                        <div className={`${AbTestStore.ABGetClassName(ABTestKeys.product_mats)}prod-option-c`}>
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`https://${Portal?.CDNDomain}/images/entities/matcombos/90_${m.mat1_id}${m.mat2_id && m.mat2_id > 0 ? `_${m.mat2_id.toString()}` : ''}.webp`}
                                />
                                <img
                                    loading="lazy"
                                    className={AbTestStore.ABGetClassName(ABTestKeys.product_mats)}
                                    width="50"
                                    height="50"
                                    src={`https://${Portal?.CDNDomain}/images/entities/matcombos/90_${m.mat1_id}${m.mat2_id && m.mat2_id > 0 ? `_${m.mat2_id.toString()}` : ''}.png`}
                                    alt={m.title}
                                />
                            </picture>
                        </div>
                        {!AbTestStore.ABIsVariant(ABTestKeys.product_mats, 3) && <div className="title">{m.title}</div>}
                        {m.mat2_id !== 36 && m.mat2_id !== 38 && (
                            <div
                                className={`${AbTestStore.ABGetClassName(ABTestKeys.product_mats)}smat-th`}
                                style={{
                                    backgroundColor: `#${m.smat_color}`,
                                }}
                            />
                        )}
                        {s.__fast_ship_orig && s.isRetail && s.prod.MatComboID === m.id && (
                            <div className={`prod-fast-shipping fast-shipping-${Portal?.PortalID}`}>
                                <i className={Portal?.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}></i>
                            </div>
                        )}
                    </div>
                ))}
        </div>
    );
});
